module.exports = __webpack_public_path__ + "media/icons/export_all-63b99019.png";